import { render, staticRenderFns } from "./InventSum.vue?vue&type=template&id=a6dcf8f0"
import script from "./InventSum.vue?vue&type=script&lang=js"
export * from "./InventSum.vue?vue&type=script&lang=js"
import style0 from "./InventSum.vue?vue&type=style&index=0&id=a6dcf8f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports